/**
 * labelConverterHelpers.ts
 * 라벨 변환 유틸리티 함수
 *
 * @description
 * - 코드 값을 사용자에게 보여줄 라벨로 변환
 * - 협력사/라이더 상태, 일차감 대상/유형 변환
 * - Y/N 값 한글 변환
 */

import {
  SUPPLIER_STATUS_LABELS,
  SupplierStatus,
} from '@/shared/constants/statusCodes';
import {
  DEDUCT_TARGET_LABELS,
  DEDUCTION_TYPE_LABELS,
  DEDUCTION_TYPE_CODES,
  DeductTarget,
  DeductionType,
} from '@/shared/constants/deductionTypes';

/**
 * 협력사 운영 상태 코드를 라벨로 변환
 */
export const getSupplierStatusLabel = (statusCode: string | null | undefined): string => {
  if (!statusCode) return '-';
  return SUPPLIER_STATUS_LABELS[statusCode as SupplierStatus] || statusCode;
};

/**
 * 일차감 대상 코드를 라벨로 변환
 */
export const getDeductTargetLabel = (categoryCode: string | null | undefined): string => {
  if (!categoryCode) return '-';
  return DEDUCT_TARGET_LABELS[categoryCode as DeductTarget] || categoryCode;
};

/**
 * 일차감 유형 코드를 라벨로 변환
 */
export const getDeductionTypeLabel = (deductType: string | null | undefined): string => {
  if (!deductType) return '-';
  return DEDUCTION_TYPE_LABELS[deductType as DeductionType] || deductType;
};

/**
 * 일차감 유형 라벨을 코드로 역변환
 */
export const getDeductionTypeCode = (deductTypeLabel: string): DeductionType | '' => {
  return DEDUCTION_TYPE_CODES[deductTypeLabel] || '';
};
